import { AggFilterCreatorFactory } from "./Factory.js";
const TYPE = 'aggregation.filters';
export default {
  id: 'molten.aggregation.FiltersClickAction',
  type: TYPE,
  onClick(data, context) {
    const {
      queryModel,
      clientProps: {
        onFilterChange
      }
    } = context;
    const aggFilter = AggFilterCreatorFactory.create(TYPE, data, {
      queryModel
    });
    if (aggFilter) {
      onFilterChange({
        data: 'filterBar',
        value: aggFilter
      });
    }
  },
  handles(data, context) {
    const {
      queryModel
    } = context;
    const aggFilter = AggFilterCreatorFactory.create(TYPE, data, {
      queryModel
    });
    return !!aggFilter;
  }
};